const LOGOS = [
  { name: "folio3", src: "/logos/folio3.png", h: 30 },
  { name: "DataFlow", src: "/logos/dataflow.png", h: 26 },
  { name: "Bosch", src: "/logos/bosch.png", h: 23 },
  { name: "NetApp", src: "/logos/netapp.png", h: 21 },
  { name: "Carrier", src: "/logos/carrier.png", h: 34 },
  { name: "Britannia", src: "/logos/britannia.png", h: 38 },
  { name: "Maruti Suzuki", src: "/logos/maruti.png", h: 27 },
];

export const Marquee = () => {
  const row = [...LOGOS, ...LOGOS, ...LOGOS];
  return (
    <div className="bg-[#211307] pt-11 lg:pt-12 pb-9 overflow-hidden select-none" data-testid="editorial-marquee">
      <p className="text-center font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#F7F5F0]/45 mb-7">
        Trusted by enterprises across industries
      </p>
      <div className="marquee-track flex items-center gap-14 lg:gap-24 w-max">
        {row.map((c, i) => (
          <img
            key={i}
            src={c.src}
            alt={`${c.name} logo`}
            style={{ height: `${c.h}px` }}
            data-testid={`customer-logo-${c.name.toLowerCase()}`}
            className="shrink-0 w-auto object-contain opacity-45 hover:opacity-100 transition-opacity duration-300"
            draggable="false"
          />
        ))}
      </div>
    </div>
  );
};
